





































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
// @ts-ignore
import emitter from 'element-ui/src/mixins/emitter';
import MaskedInput from 'vue-text-mask';
import Cleave from 'vue-cleave-component';
// import { Input } from 'element-ui';
@Component({
  name: 'lb-input',
  inheritAttrs: false,
  mixins: [emitter],
  components: {
  //   // 'el-input': Input,
    Cleave,
    MaskedInput
  }
})
export default class extends Vue {
  @Prop() private value!: string | number;
  @Prop() private label!: string;
  @Prop({ type: Boolean, default: false }) private labelFloat!: boolean;
  @Prop({ default: 'none' }) private resize!: string;
  @Prop() private form!: string;
  @Prop({ type: Boolean, default: false }) private disabled!: boolean;
  @Prop() private placeholder!: string;
  @Prop({ type: Boolean, default: false }) private readonly!: boolean;
  @Prop({ default: 'text' }) private type!: string;
  @Prop() private autosize!: boolean | object;
  @Prop({ default: 'off' }) private autocomplete!: string;
  @Prop({ type: Boolean, default: true }) private validateEvent!: boolean;
  @Prop() private suffixIcon!: string;
  @Prop() private prefixIcon!: string;
  @Prop({ type: Boolean, default: false }) private clearable!: boolean;
  @Prop({ type: Boolean, default: false }) private showPassword!: boolean;
  @Prop({ type: Boolean, default: false }) private showWordLimit!: boolean;
  @Prop({ type: Boolean, default: true }) private positiveOnly!: boolean;
  @Prop() private tabindex!: string;
  @Prop() private maxNumber!: number;
  @Prop() private minNumber!: number;
  @Prop({ type: Number, default: 0 }) private point!: number;
  // number
  @Prop({ type: Number, default: 15 }) private integer!: number;
  @Prop({ type: Number, default: 2 }) private decimal!: number;
  @Prop({ type: String, default: 'none' }) private numeralThousandsGroupStyle!: string;
  @Prop({ type: Boolean, default: false }) private textareaLine!: boolean; // textarea时的样式

  private localValue = this.value;
  private localType = this.type;
  private inputFocus = false;
  private isOpenEyes = false;
  private cleaveOptions = {
    numeral: true,
    numeralIntegerScale: this.integer,
    numeralDecimalScale: this.decimal,
    numeralThousandsGroupStyle: this.numeralThousandsGroupStyle,
    numeralPositiveOnly: this.positiveOnly
  }

  get isLabelFloat() {
    return this.labelFloat && (this.inputFocus || this.localValue);
  }

  private handleOpenEyes(flag: Boolean) {
    if (flag) {
      this.isOpenEyes = true;
      this.localType = 'text';
      // @ts-ignore
      if (this.$refs.lbInput.$el.children[0].style['0'] === '-webkit-text-security') {
        // @ts-ignore
        this.$refs.lbInput.$el.children[0].style = ''
      }
    } else {
      this.isOpenEyes = false;
      this.localType = 'password';
    }
  }

  private stopScrollFun(evt: any) {
    evt = evt || window.event;
    if(evt.preventDefault) {
      // Firefox
      evt.preventDefault();
      evt.stopPropagation();
    } else {
      // IE
      evt.cancelBubble=true;
      evt.returnValue = false;
    }
    return false;
  }

  private handleInput(val: string) {
    this.$emit('input', val);
  }

  private handleFocus() {
    this.inputFocus = true;
    this.$emit('focus');
  }

  private handleBlur() {
    this.inputFocus = false;
    this.$emit('blur');
  }

  private handleEnter() {
    this.$emit('enter');
  }

  private handleClear() {
    this.$emit('clear');
  }

  private select() {
    // @ts-ignore
    this.$refs.lbInput.select()
  }

  private focus() {
    // @ts-ignore
    this.$refs.lbInput.focus()
  }

  private blur() {
    // @ts-ignore
    this.$refs.lbInput.blur()
  }

  @Watch('value')
  private onValueChange(val: string) {
    this.localValue = val;
    // @ts-ignore
    this.dispatch('ElFormItem', 'el.form.change', [val]);
  }

  @Watch('localValue')
  private onLocalValueChange(val: string) {
    this.$emit('input', val);
  }
}
